import Vuei18n from "vue-i18n"
import Vue from "vue"
import store from "@/store"
const messages = {
    fr: require("@/lang/fr.json"),
    de: require("@/lang/de.json"),
    en: require("@/lang/en.json"),
    nl: require("@/lang/nl.json"),
}

Vue.use(Vuei18n)
// VueI18n instance
const i18n = new Vuei18n({ locale: store.getters["user/locale"], messages })

store.watch(
    (state) => {
        return state.user.locale
    },
    async (locale) => {
        i18n.locale = locale
        const html = document.documentElement
        html.setAttribute("lang", locale)
    },
    { immediate: true }
)
export default i18n
